import React from "react";
import { Check, MessageCircle } from "lucide-react";
import { Section, Reveal, BrutalButton, useLead } from "./shared";
import { OFFER_INCLUDES, PRICING, LINKS } from "../../lib/site";

export default function Offer() {
  const { openLead } = useLead();
  return (
    <Section id="pricing" bg="bg-brand-blue" dark>
      <Reveal className="max-w-3xl">
        <span className="inline-flex items-center gap-2 rounded-full border-2 border-white/40 px-4 py-1.5 text-[11px] sm:text-xs font-bold uppercase tracking-[0.2em] text-white">
          <span className="h-2 w-2 rounded-full bg-brand-yellow" /> The Offer
        </span>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-[52px] leading-[1.02] mt-5 text-white">
          What Would It Be Worth to Build a Customer Acquisition Asset You Actually <span className="text-brand-yellow">Own?</span>
        </h2>
        <p className="font-serif-e text-lg sm:text-xl text-white/80 mt-5">
          Creating a course is easy. Finding customers is hard.
        </p>
      </Reveal>

      <div className="grid lg:grid-cols-[1.1fr_0.9fr] gap-6 mt-12 items-stretch">
        {/* Includes */}
        <Reveal>
          <div className="h-full rounded-[30px] border-2 border-brand-black bg-brand-cream text-brand-ink p-7 sm:p-9">
            <p className="font-display text-2xl">Everything Included</p>
            <ul className="mt-5 grid sm:grid-cols-2 gap-x-6 gap-y-3">
              {OFFER_INCLUDES.map((o) => (
                <li key={o} className="flex items-start gap-3">
                  <span className="mt-0.5 h-6 w-6 rounded-full bg-brand-green flex items-center justify-center shrink-0"><Check size={14} className="text-white" /></span>
                  <span className="text-sm sm:text-base">{o}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>

        {/* Pricing card */}
        <Reveal delay={0.1}>
          <div className="h-full rounded-[30px] border-2 border-brand-black bg-brand-yellow text-brand-ink p-7 sm:p-9 flex flex-col"
            style={{ boxShadow: "10px 12px 0 #111111" }}>
            <div className="flex items-center justify-between">
              <span className="rounded-full bg-brand-black text-brand-yellow text-[10px] font-bold uppercase tracking-widest px-3 py-1">Current Batch</span>
              <span className="text-xs font-bold" data-testid="seats-remaining">{PRICING.seatsRemaining} of {PRICING.seats} seats left</span>
            </div>
            <p className="mt-6 text-brand-ink/60 line-through font-semibold text-lg">₹{PRICING.reference}</p>
            <p className="font-display text-6xl sm:text-7xl leading-none mt-1">₹{PRICING.current}</p>
            <p className="text-sm font-semibold mt-2">One-time payment · 12-month program</p>
            <p className="text-sm text-brand-ink/70 mt-1">≈ ₹{PRICING.monthly} per month equivalent</p>

            <div className="mt-6 space-y-3">
              <BrutalButton onClick={openLead} variant="red" full data-testid="offer-join-button">Join the Current Batch</BrutalButton>
              <BrutalButton href={LINKS.whatsapp} variant="dark" full data-testid="offer-ask-button">
                <MessageCircle size={18} /> Ask Ratish a Question
              </BrutalButton>
            </div>
            <p className="text-xs text-brand-ink/60 mt-4 text-center">Limited to {PRICING.seats} participants per batch · UPI: {LINKS.upiId}</p>
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
